/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'shield': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M23.26 1.13c.48-.17 1-.17 1.48 0l16.89 6.28A2.1 2.1 0 0 1 43 9.36V24c0 7.2-4.82 12.96-9.17 16.73a47.86 47.86 0 0 1-8.82 6.02l-.04.02h-.02L24 44.92l-.95 1.87-.02-.01-.04-.02a15.37 15.37 0 0 1-.74-.4 47.87 47.87 0 0 1-8.09-5.62C9.83 36.96 5 31.21 5 24V9.36c0-.87.55-1.65 1.37-1.95l16.89-6.28zM24 44.91l-.95 1.87c.6.3 1.3.3 1.9 0L24 44.91zm0-2.38a43.66 43.66 0 0 0 7.05-4.95c4.1-3.54 7.73-8.24 7.73-13.58V10.81L24 5.32l-14.78 5.5V24c0 5.34 3.63 10.04 7.73 13.59A43.66 43.66 0 0 0 24 42.53z"/>'
  }
})
